import { HTMLProps, ReactNode, useEffect, useRef, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export const MaxWidthElipsisBox = ({
  children,
  maxWidth,
  suffix,
  ...rest
}: {
  children: ReactNode;
  suffix?: ReactNode;
  maxWidth: string | number;
} & HTMLProps<HTMLDivElement>) => {
  const renderTooltip = (props) =>
    offsetWidth < scrollWidth ? <Tooltip {...props}>{children}</Tooltip> : <></>;

  const divEl = useRef<HTMLDivElement>(null);
  const [offsetWidth, setOffsetWidth] = useState(0);
  const [scrollWidth, setScrollWidth] = useState(0);

  useEffect(() => {
    if (divEl.current) {
      setOffsetWidth(divEl.current.offsetWidth);
      setScrollWidth(divEl.current.scrollWidth);
    }
  }, [divEl.current]);

  return (
    <div {...rest}>
      <OverlayTrigger overlay={renderTooltip}>
        <div
          ref={divEl}
          className="d-inline-block align-middle"
          style={{ maxWidth, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
        >
          {children}
        </div>
      </OverlayTrigger>
      {suffix && <div className="d-inline-block align-top">{suffix}</div>}
    </div>
  );
};
